<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-tristate--disabled': disabledCombined}]" class="hm-tristate">
    <div class="hm-tristate__options__wrapper">
      <div class="hm-tristate__options">
        <div :class="{'active': isNil(internalValue) }" class="hm-tristate__option" @click="internalValue = null">
          Inherit
        </div>
        <div :class="{'active': internalValue === true }" class="hm-tristate__option" @click="internalValue = true">
          Closed
        </div>
        <div :class="{'active': internalValue === false }" class="hm-tristate__option" @click="internalValue = false">
          Open
        </div>
      </div>
    </div>
    <div class="hm-tristate__help" v-html="help" />
    <div class="hm-tristate__label" v-html="label" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'HmTristate',

  mixins: [HmInputMixin, GridMixin],

  methods: {
    toggleState: function () {
      if (!this.disabledCombined) {
        this.internalValue = !this.internalValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';
  .hm-tristate {
    position: relative;
    padding-top: 0.6rem;
    &--disabled {
      pointer-events: none;
      .hm-tristate {
        &__option {
          background-color: $lightgray;
          color: $middlegray!important;
        }
      }
    }
    &__options {
      display: grid;
      grid-template-columns: repeat(3, minmax(6.85rem, 1fr));
      grid-template-rows: 3.2rem;
      // grid-template-columns: repeat(3, 1fr);
      border: 0.1rem solid $middlegray;
      border-radius: 0.3rem;
      align-items: center;
      justify-items: center;
      &__wrapper {
        display: flex;
        width: auto;
      }
    }
    &__option {
      border-right: 0.1rem solid $middlegray;
      width: 100%;
      display: flex;
      height: 100%;
      align-items: center;
      justify-items: center;
      align-self: center;
      justify-self: center;
      align-content: center;
      justify-content: center;
      &:last-of-type {
        border-right: none;
      }
      color: $middlegray;
      .hm-icon {
        width: 3rem;
        height: 3rem;
      }
      &.active {
        color: $text;
      }
      &:hover {
        cursor: pointer;
        color: $text;
      }
    }
    &__help {
      color: $gray;
      font-size: 1.1rem;
      padding-left: 1rem;
      height: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 0.3rem;
      margin-top: 0.3rem;
    }
    &__label {
      position: absolute;
      top: 0;
      left: 0.6rem;
      font-size: 1.1rem;
      color: $gray;
      transition: all 0.2s ease;
      z-index: 2;
      pointer-events: none;
      background-color: $white;
      padding: 0 0.4rem;
      border-radius: 0.3rem;
      will-change: top, font-size;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmTriState.vue